export const GET_BARCODE_CATEGORIES = 'GET_BARCODE_CATEGORIES';
export const GET_BARCODE_CATEGORIES_SUCCESS = 'GET_BARCODE_CATEGORIES_SUCCESS';
export const GET_BARCODE_CATEGORIES_ERROR = 'GET_BARCODE_CATEGORIES_ERROR';
export const RESET_BARCODE_CATEGORIES = 'RESET_BARCODE_CATEGORIES';

export const GET_USER_BARCODE_CATEGORIES = 'GET_USER_BARCODE_CATEGORIES';
export const GET_USER_BARCODE_CATEGORIES_SUCCESS = 'GET_USER_BARCODE_CATEGORIES_SUCCESS';
export const GET_USER_BARCODE_CATEGORIES_ERROR = 'GET_USER_BARCODE_CATEGORIES_ERROR';
export const RESET_USER_BARCODE_CATEGORIES = 'RESET_USER_BARCODE_CATEGORIES';

export const ADD_USER_CATEGORY = 'ADD_USER_CATEGORY';
export const ADD_USER_CATEGORY_SUCCESS = 'ADD_USER_CATEGORY_SUCCESS';
export const ADD_USER_CATEGORY_ERROR = 'ADD_USER_CATEGORY_ERROR';

export const REMOVE_USER_CATEGORY = 'REMOVE_USER_CATEGORY';
export const REMOVE_USER_CATEGORY_SUCCESS = 'REMOVE_USER_CATEGORY_SUCCESS';
export const REMOVE_USER_CATEGORY_ERROR = 'REMOVE_USER_CATEGORY_ERROR';
